const Constants = { version: '1.0' };

export default Constants;
